export default __webpack_public_path__ + "static/media/moon.927f0df9.svg";